// lang.js
export const SET_LOCALE = 'SET_LOCALE'

export const FETCH_CATALOG_PRODUCTS = 'FETCH_CATALOG_PRODUCTS'
export const FETCH_CATALOG_PRODUCTS_SUCCESS = 'FETCH_CATALOG_PRODUCTS_SUCCESS'
export const FETCH_CATALOG_PRODUCTS_FAILURE = 'FETCH_CATALOG_PRODUCTS_FAILURE'
export const TOGGLE_CATALOG_PRODUCTS_TAGGED_PRODUCT = 'TOGGLE_CATALOG_PRODUCTS_TAGGED_PRODUCT'
export const SET_CATALOG_PRODUCTS_ITEMS = 'SET_CATALOG_PRODUCTS_ITEMS'
export const TOGGLE_CATALOG_PRODUCTS_PRODUCT_PROPERTY = 'TOGGLE_CATALOG_PRODUCTS_PRODUCT_PROPERTY'
export const TOGGLE_CATALOG_PRODUCTS_SHOW_NOTES = 'TOGGLE_CATALOG_PRODUCTS_SHOW_NOTES'
export const SET_CATALOG_PRODUCTS_VIEW_TYPE = 'SET_CATALOG_PRODUCTS_VIEW_TYPE'
export const SET_CATALOG_PRODUCTS_SHOW_LOADING = 'SET_CATALOG_PRODUCTS_SHOW_LOADING'
export const SET_CATALOG_PRODUCTS_SELECTED_SORT_BY = 'SET_CATALOG_PRODUCTS_SELECTED_SORT_BY'
export const UPDATE_CATALOG_PRODUCTS_PRODUCT_NOTE = 'UPDATE_CATALOG_PRODUCTS_PRODUCT_NOTE'
export const CLEAR_CATALOG_PRODUCTS = 'CLEAR_CATALOG_PRODUCTS'
export const TOGGLE_SELECTED_PRODUCTS = 'TOGGLE_SELECTED_PRODUCTS'
export const CLEAR_SELECTED_PRODUCTS = 'CLEAR_SELECTED_PRODUCTS'
export const SET_ACTIVE_COLLECTION = 'SET_ACTIVE_COLLECTION'
export const SET_SELECTED_CHECKBOX = 'SET_SELECTED_CHECKBOX'

// dashboard.js
export const FETCH_BUYER_DASHBOARD = 'FETCH_BUYER_DASHBOARD'
export const FETCH_BUYER_DASHBOARD_SUCCESS = 'FETCH_BUYER_DASHBOARD_SUCCESS'
export const FETCH_BUYER_DASHBOARD_FAILURE = 'FETCH_BUYER_DASHBOARD_FAILURE'

export const FETCH_TRADESHOWS_SUCCESS = 'FETCH_TRADESHOWS_SUCCESS'
export const FETCH_DRAFT_ORDERS_SUCCESS = 'FETCH_DRAFT_ORDERS_SUCCESS'
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS'
export const FETCH_INVOICE_STATUSES_SUCCESS = 'FETCH_INVOICE_STATUSES_SUCCESS'
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS'
export const FETCH_COLLECTIONS_SUCCESS = 'FETCH_COLLECTIONS_SUCCESS'

export const FETCH_ORDER_SUMMARY = 'FETCH_ORDER_SUMMARY'
export const FETCH_ORDER_SUMMARY_SUCCESS = 'FETCH_ORDER_SUMMARY_SUCCESS'
export const FETCH_ORDER_SUMMARY_FAILURE = 'FETCH_ORDER_SUMMARY_FAILURE'

// collections.js
export const FETCH_MY_COLLECTIONS = 'FETCH_MY_COLLECTIONS'
export const FETCH_MY_COLLECTIONS_SUCCESS = 'FETCH_MY_COLLECTIONS_SUCCESS'
export const FETCH_MY_COLLECTIONS_FAILURE = 'FETCH_MY_COLLECTIONS_FAILURE'
export const TOGGLE_SELECTED_MY_COLLECTIONS_ITEM = 'TOGGLE_SELECTED_MY_COLLECTIONS_ITEM'

// history.js
export const FETCH_ORDER_HISTORY_SUCCESS = 'FETCH_ORDER_HISTORY_SUCCESS'
export const FETCH_DRAFT_ORDER_HISTORY_SUCCESS = 'FETCH_DRAFT_ORDER_HISTORY_SUCCESS'
export const FETCH_INVOICE_HISTORY_SUCCESS = 'FETCH_INVOICE_HISTORY_SUCCESS'
export const FETCH_FILTER_TAB_ORDER_HISTORY_SUCCESS = 'FETCH_FILTER_TAB_ORDER_HISTORY_SUCCESS'
export const SET_HISTORY_FILTER_TAB = 'SET_HISTORY_FILTER_TAB'

// contacts.js
export const FETCH_ADMIN_CONTACTS = 'FETCH_ADMIN_CONTACTS'
export const FETCH_ADMIN_CONTACTS_SUCCESS = 'FETCH_ADMIN_CONTACTS_SUCCESS'
export const FETCH_ADMIN_CONTACTS_FAILURE = 'FETCH_ADMIN_CONTACTS_FAILURE'

export const FETCH_ADMIN_CONTACT_BY_ID = 'FETCH_ADMIN_CONTACT_BY_ID'
export const UPDATE_COMPANY_RELATION = 'UPDATE_COMPANY_RELATION'
export const UPDATE_COMPANY_INFO = 'UPDATE_COMPANY_INFO'

export const FETCH_FILTER_TAB_CONTACTS_SUCCESS = 'FETCH_FILTER_TAB_CONTACTS_SUCCESS'
export const SET_CONTACTS_FILTER_TAB = 'SET_CONTACTS_FILTER_TAB'

// buyers.js
export const FETCH_BUYERS = 'FETCH_BUYERS'
export const FETCH_BUYERS_SUCCESS = 'FETCH_BUYERS_SUCCESS'
export const FETCH_BUYERS_FAILURE = 'FETCH_BUYERS_FAILURE'

// addresses.js
export const FETCH_ADDRESSES = 'FETCH_ADDRESSES'
export const FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS'
export const FETCH_ADDRESSES_FAILURE = 'FETCH_ADDRESSES_FAILURE'

// menus.js
export const FETCH_COMMON_MENU = 'FETCH_COMMON_MENU'
export const FETCH_PRODUCT_FILTER_TABS_MENU = 'FETCH_PRODUCT_FILTER_TABS_MENU'
export const FETCH_PRODUCT_DEFAULT_FILTER_TABS_MENU = 'FETCH_PRODUCT_DEFAULT_FILTER_TABS_MENU'
export const SET_SELECTED_CHILDREN_CHECKBOX = 'SET_SELECTED_CHILDREN_CHECKBOX'
export const UNSELECT_ALL_CHILDREN_CHECKBOX = 'UNSELECT_ALL_CHILDREN_CHECKBOX'
export const FOLD_ALL_EXPANDED_ITEMS = 'FOLD_ALL_EXPANDED_ITEMS'
export const SET_MENUS_EDIT_MODE = 'SET_MENUS_EDIT_MODE'
export const SET_MENUS_ADMIN_VIEW = 'SET_MENUS_ADMIN_VIEW'
export const SET_ROUTE_PARAMS_VIEW = 'SET_ROUTE_PARAMS_VIEW'
export const FILTER_PRODUCTS_CHECKS = 'FILTER_PRODUCTS_CHECKS'
export const FILTER_CHECK_BOX = 'FILTER_CHECK_BOX'
export const SEARCH_FILTER_CHECK = 'SEARCH_FILTER_CHECK'
export const SET_PRODUCTS_FILTERS = 'SET_PRODUCTS_FILTERS'
export const SET_EXPAND_SIDE_FILTER = 'SET_EXPAND_SIDE_FILTER'
export const SET_SELECTED_SEARCH_FILTER_CHECKBOX = 'SET_SELECTED_SEARCH_FILTER_CHECKBOX'

export const CLEAR_TAGS_COUNT = 'CLEAR_TAGS_COUNT'

// tags.js
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS'
export const TOGGLE_SELECTED_TAG_ITEM = 'TOGGLE_SELECTED_TAG_ITEM'
export const SET_TAGS_POPULAR_TAGS = 'SET_TAGS_POPULAR_TAGS'
export const SET_TAGS_MY_TAGS = 'SET_TAGS_MY_TAGS'

// add_edit_order_modal
export const SET_ADD_EDIT_ORDER_MODAL_IS_EDIT = 'SET_ADD_EDIT_ORDER_MODAL_IS_EDIT'
export const SET_ADD_EDIT_ORDER_MODAL_WITH_CREATE_ACTIVE_ORDER_PRODUCT = 'SET_ADD_EDIT_ORDER_MODAL_WITH_CREATE_ACTIVE_ORDER_PRODUCT'
export const SET_ADD_EDIT_ORDER_MODAL_FORM_DATA_OBJ = 'SET_ADD_EDIT_ORDER_MODAL_FORM_DATA_OBJ'

// Company
export const SET_COMPANY = 'SET_COMPANY'
export const ADD_COMPANY_BUYER = 'ADD_COMPANY_BUYER'
export const SET_COMPANIES = 'SET_COMPANIES'

// approval requests
export const FETCH_APPROVAL_REQUESTS_REQUEST = 'FETCH_APPROVAL_REQUESTS_REQUEST'
export const SET_APPROVAL_REQUESTS = 'SET_APPROVAL_REQUESTS'
export const FETCH_APPROVAL_REQUESTS_FAILURE = 'FETCH_APPROVAL_REQUESTS_FAILURE'
export const UPDATE_APPROVAL_REQUEST_STATUS = 'UPDATE_APPROVAL_REQUEST_STATUS'

export const SET_ERROR_STATE = 'SET_ERROR_STATE'
export const SET_APPROVAL_COUNT = 'SET_APPROVAL_COUNT'
export const SET_APPROVAL_REQUEST = 'SET_APPROVAL_REQUEST'
export const SET_RESPONSE_MSG = 'SET_RESPONSE_MSG'

// Coupon mutations
export const SET_COUPONS = 'SET_COUPONS'
export const SET_CURRENT_COUPON = 'SET_CURRENT_COUPON'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const REMOVE_COUPON = 'REMOVE_COUPON'

// Digital Catalog
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'

// Shipping Methods
export const SET_SHIPPING_METHODS = 'SET_SHIPPING_METHODS'
export const SET_CURRENT_SHIPPING_METHOD = 'SET_CURRENT_SHIPPING_METHOD'
export const SET_SHIPPING_LOADING = 'SET_SHIPPING_LOADING'
export const SET_SHIPPING_ERROR = 'SET_SHIPPING_ERROR'
export const UPDATE_SHIPPING_METHOD = 'UPDATE_SHIPPING_METHOD'
export const REMOVE_SHIPPING_METHOD = 'REMOVE_SHIPPING_METHOD'

// Payment Terms
export const SET_PAYMENT_TERMS = 'SET_PAYMENT_TERMS'
export const SET_PAYMENT_TERMS_LOADING = 'SET_PAYMENT_TERMS_LOADING'
export const SET_PAYMENT_TERMS_ERROR = 'SET_PAYMENT_TERMS_ERROR'
export const REMOVE_PAYMENT_TERM = 'REMOVE_PAYMENT_TERM'

// Order Locations
export const SET_ORDER_LOCATIONS = 'SET_ORDER_LOCATIONS'
export const SET_ORDER_LOCATIONS_LOADING = 'SET_ORDER_LOCATIONS_LOADING'
export const SET_ORDER_LOCATIONS_ERROR = 'SET_ORDER_LOCATIONS_ERROR'
export const REMOVE_ORDER_LOCATION = 'REMOVE_ORDER_LOCATION'

// Discounts
export const SET_DISCOUNTS = 'SET_DISCOUNTS'
export const SET_DISCOUNTS_LOADING = 'SET_DISCOUNTS_LOADING'
export const SET_DISCOUNTS_ERROR = 'SET_DISCOUNTS_ERROR'
export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT'

// Website Header Logo
export const SET_WEBSITE_HEADER_LOGOS = 'SET_WEBSITE_HEADER_LOGOS'
export const SET_WEBSITE_HEADER_LOGO_ACTIVE = 'SET_WEBSITE_HEADER_LOGO_ACTIVE'
export const SET_WEBSITE_HEADER_LOGO_LOADING = 'SET_WEBSITE_HEADER_LOGO_LOADING'
export const SET_WEBSITE_HEADER_LOGO_ERROR = 'SET_WEBSITE_HEADER_LOGO_ERROR'
export const REMOVE_WEBSITE_HEADER_LOGO = 'REMOVE_WEBSITE_HEADER_LOGO'

// Global Settings (key/value flags)
export const SET_PUBLIC_SETTINGS = 'SET_PUBLIC_SETTINGS'

// Mega Menu Header Configuration
export const SET_MEGA_MENU_ITEMS = 'SET_MEGA_MENU_ITEMS'
export const SET_MEGA_MENU_PUBLIC_ITEMS = 'SET_MEGA_MENU_PUBLIC_ITEMS'
export const SET_MEGA_MENU_ITEM = 'SET_MEGA_MENU_ITEM'
export const SET_MEGA_MENU_IMAGES = 'SET_MEGA_MENU_IMAGES'
export const UPSERT_MEGA_MENU_IMAGE = 'UPSERT_MEGA_MENU_IMAGE'
export const REMOVE_MEGA_MENU_ITEM = 'REMOVE_MEGA_MENU_ITEM'
export const SET_MEGA_MENU_LOADING = 'SET_MEGA_MENU_LOADING'
export const SET_MEGA_MENU_SAVING = 'SET_MEGA_MENU_SAVING'
export const SET_MEGA_MENU_ERROR = 'SET_MEGA_MENU_ERROR'

// page_headers.js
export const SET_PAGE_HEADER = 'SET_PAGE_HEADER'
